// import "dotenv/config";

import * as Sentry from "@sentry/react";
import { env } from "./env";

const BASE_SAMPLING_RATE = parseFloat(
  env.REACT_APP_SENTRY_SAMPLING_RATE || "0.01"
);

if (env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    environment:
      window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("staging") ||
      window.location.hostname.includes("preprod")
        ? "development"
        : "production",
    dsn: env.REACT_APP_SENTRY_DSN,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sampleRate: BASE_SAMPLING_RATE,
    sendDefaultPii: true,
    tracesSampleRate: BASE_SAMPLING_RATE,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ["localhost", /^https:.*/],
  });
}
